import React, { Component } from 'react';
import './App.css';
import {connect} from 'react-redux';
import LoginDlg from './LoginDlg';
import UserInfo from './UserInfo';
import { loadInfo } from './actions';

class App extends Component {
  componentDidMount() {
    let {info,dispatch} = this.props;
    const nev = localStorage.getItem('nev');
    const kod = localStorage.getItem('kod');
    if(nev && kod){
      dispatch(loadInfo(nev,kod));
    }
  }

  render() {
    return <div className="App bg-dark">{this.props.loggedin? <UserInfo /> : <LoginDlg/>}</div>;
  }
}

export default connect(state => ({loggedin: state.userInfo}), dispatch => ({dispatch}))(App);



// WEBPACK FOOTER //
// ./src/App.js